import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/eye-wear"
    path="business/products/eye-wear"
    element={<AsyncPage />}
  />,
];
